import { Component, OnInit, ElementRef, Renderer } from '@angular/core';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { Headers } from '@angular/http';

import { MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes';
import 'bootbox';

@Component({
  selector: 'app-cartao',
  templateUrl: './cartao.component.html'
})
export class CartaoComponent implements OnInit {

  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public cartaoDestino: any;
  public cartaoLocalizado: any;
  public transferenciaCartao: any;
  public valorPontos;
  public taxaTransferencia;
  public processando: boolean;
  public epwd;
  public limiteTransferencia;
  public transferencia;

  constructor(public mainService: MainService, public router: Router,
    location: LocationStrategy, private elRef: ElementRef, private renderer: Renderer) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.processando = false;
    this.getTaxaTransferencia();
    this.getLimiteTransferencia();
    this.mainService.saldoService.initialize();

  }

  public localizaCartao() {
    if (this.cartaoDestino !== '' && this.cartaoDestino !== undefined &&
      this.cartaoDestino !== null) {
      this.processando = true;
      this.mainService.http.pathRest().get('cartao/transferencia/cartao/localizar/' + this.cartaoDestino + '/', true)
        .subscribe(
        sucesso => {
          this.cartaoLocalizado = sucesso.json();
          this.processando = false;
        }, error => {
          this.cartaoLocalizado = undefined;
          this.processando = false;
          this.bootboxAlertComId.alerta(error.text());
        });
    } else {
      this.bootboxAlertComId.alerta('Informe o número do cartão destinatário');
    }
  }

  public calcularTotal() {
    return this.taxaTransferencia + (this.valorPontos === undefined || this.valorPontos === '' ? 0 : parseInt(this.valorPontos, 10));
  };

  public save() {

    this.transferencia = {};
    this.transferencia.valorPontos = this.valorPontos;
    this.transferencia.destino = this.cartaoLocalizado;

    const url = 'cartao/transferencia/cartao/';
    const cabecalho: Headers = new Headers();
    cabecalho.append('Authorization', 'Basic ' + this.mainService.sessionService.getAuthBasic());
    cabecalho.append('X-Auth-Ep', this.epwd);
    this.mainService.http.pathRest().post(url, this.transferencia, true, cabecalho)
      .subscribe(
      sucesso => {
        this.mainService.saldoService.initialize();
        this.router.navigate(['/transferencias']);
        this.bootboxAlertComId.alerta('Transferência para cartão realizada com sucesso!');
      },
      error => {
        this.bootboxAlertComId.alerta(error.text());
        this.processando = false;
      });
  }

  public getTaxaTransferencia() {
    this.mainService.http.pathRest().get('cartao/transferencia/cartao/tarifa/', true)
      .subscribe(
      sucesso => { this.taxaTransferencia = sucesso.json(); },
      error => { }
      );
  }

  public getLimiteTransferencia() {

    this.mainService.http.pathRest().get('cartao/transferencia/cartao/limite/', true)
      .subscribe(
      sucesso => { this.limiteTransferencia = sucesso.json(); },
      error => { }
      );
  }

  public clearCartao() {

    this.cartaoLocalizado = undefined;
    this.valorPontos = undefined;
    this.epwd = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/transferencia/cartao/cartao.component.ts